/**
 * Ponte de autenticação do app desktop — HEADLESS (não renderiza nada).
 *
 * O menu nativo Nitro → "Sair" pede logout via IPC. Aqui chamamos
 * authStore.logout() E navegamos para a rota de login — só logout() deixaria a
 * URL em "/" (sem auth), caindo no fallback AuthError; a tela de login vive numa
 * rota própria (a mesma que o AppRouter usa).
 *
 * No web não faz nada (onLogout devolve um no-op sem a ponte desktop).
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { onLogout } from "./platform";
import { useAuthStore } from "~/store/authStore";

// Mesma rota de login do AppRouter (não há constante compartilhada).
const LOGIN_ROUTE = "/a7f3e9d2-4b1c-4a8f-9e3d-7c2b5a8f1e4d";

const DesktopAuthBridge = () => {
  const navigate = useNavigate();

  useEffect(() => {
    return onLogout(() => {
      useAuthStore.getState().logout();
      navigate(LOGIN_ROUTE);
    });
  }, [navigate]);

  return null;
};

export default DesktopAuthBridge;
